
import { MODULE } from "@/config/modules";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			modules: [] as Module[]
		};
	},
	props: {
		value: {
			type: Array as ()=>MODULE[],
			required: true
		}
	},
	computed: {
		items():ISelectItem<MODULE>[]{
			return this.modules.map(m=>{
				return {
					text: m.name,
					value: m.id
				} as ISelectItem<MODULE>;
			});
		}
	},
	async created(){
		this.modules = await ModuleService.getModules();
	}
});
